import React, { createContext, useContext, useMemo } from 'react';
import { useStateWithLocalStorage } from '@util/hooks/useStateWithLocalStorage';

const LocaleContext = createContext({});

const defaultValues = {
  locale: {
    localeDetails: {
      isoCode: 'US',
      exclusive: false,
      name: 'United States',
      enabled: true,
      defaultToSubscription: true,
      defaultLocale: 'en-us',
    },
    geoLocated: false,
  },
  currency: 'USD',
  language: 'English (US)',
};
function LocaleProvider({ children }) {
  const [locale, setLocale] = useStateWithLocalStorage(
    'locale',
    defaultValues.locale
  );
  const [selectedCurrency, setSelectedCurrency] = useStateWithLocalStorage(
    'selectedCurrency',
    defaultValues.currency
  );
  const [selectedLanguage, setSelectedLanguage] = useStateWithLocalStorage(
    'selectedLanguage',
    defaultValues.language
  );

  const contextValue = useMemo(
    () => ({
      locale,
      setLocale,
      selectedCurrency,
      setSelectedCurrency,
      selectedLanguage,
      setSelectedLanguage,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [locale, selectedCurrency, selectedLanguage]
  );

  return (
    <LocaleContext.Provider value={contextValue}>
      {children}
    </LocaleContext.Provider>
  );
}

function useLocale() {
  const context = useContext(LocaleContext);
  if (context === undefined) {
    throw new Error('useLocale must be used within a LocaleContext');
  }

  return context;
}

export { LocaleProvider, useLocale };
